import './App.css';
import NavImage from "./Pro2.jpg"; // Single shared nav image for both links

function Home() {
  return (
    <div className="home-container">
      <div className="overlay">
        <div className="image-links">
          <div className="image-block">
            <a href="https://talentconsulting.ai/dashboard" target="_blank" rel="noopener noreferrer">
              <img src={NavImage} alt="Sivu 1" className="nav-image" />
            </a>
            <p className="image-label">Consultant login</p>
          </div>

          <div className="image-block">
            <a href="https://talentconsulting.ai/interview" target="_blank" rel="noopener noreferrer">
              <img src={NavImage} alt="Sivu 3" className="nav-image" />
            </a>
            <p className="image-label">Interview</p>
          </div>
        </div>
      </div>
    </div>
  );

}

export default Home;
